import React, { Component } from 'react';
import './login.css'
import { Link } from 'react-router-dom';
import {
    Col, Row, Form, Button,
} from 'reactstrap';

import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoginRequest, changeLang } from '../../../Redux/Action/LoginAction'
import RenderField from '../../../Components/Fields/fields'
import { Inputs } from './inputSettings'
import { Redirect } from 'react-router-dom';
import validate from './validation';
import LoadingBar from 'react-redux-loading-bar'
import Logo from '../../../Assets/images/Logo.png'
import String from '../../../Assets/locals'
import Loading from '../../../Components/Loading/Loading'

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            closeAll: false,
            RedirectTo: false,
            code: null,
            codeErr: false,
            userCode: null
        };


    }
    componentWillMount() {
        let lang = localStorage.getItem("JazanLanguage") ? JSON.parse(localStorage.getItem("JazanLanguage")) : null
        if (lang) {
            this.props.changeLang(lang)
        } else {
            this.props.changeLang(JSON.parse(localStorage.getItem("ar")))
        }
        this.GenerateCode()
    }

    GenerateCode() {
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let text = "";

        for (let i = 0; i < 5; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        this.setState({ code: text })
    }

    onSubmit = (values) => {
        this.setState({ userCode: values.caption })
        if (values.caption === this.state.code) {

            let data = {
                email: values.email,
                password: values.password,
                type: localStorage.getItem("JazanType")
            }
            this.props.LoginRequest(data, this.props.lang)

        } else {
            this.setState({ codeErr: true })
        }
    }
    render() {
        const { handleSubmit, submitting } = this.props
        String.setLanguage(this.props.lang)
        let code = this.state.code
        let type = localStorage.getItem("JazanType")
        let lang = this.props.lang

        if (this.state.userCode === this.state.code) {
            this.setState({ codeErr: false, userCode: null })
        }

        if (this.props.token) {
            if (this.props.location.state) {
                return (
                    <Redirect to={this.props.location.state.redirect} />
                )
            } else {
                if (type === 'MAGAZINE')
                    return (
                        <Redirect to='/Magazin' />
                    )
                if (type === 'PROMOTION')
                    return (
                        <Redirect to='/Promotion' />
                    )
            }
        }

        return (
            <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '5px', zIndex: 1000, backgroundColor: "#006B30" }} />
                </div>
                
                <div className="bg-login">
                {this.props.loading && <Loading />}
                    <div className="container">
                        <div className="login-form" >
                            <div style={{ textAlign: "center" }}><img src={Logo} className="logo" alt="Logo" /></div>
                            {/* <h3>{String.logintitle}</h3> */}
                            <Row className="d-flex flex-row-reverse">
                                <Col md="12"> <h3 style={{ float: lang === "ar" ? "right" : 'left' }}> {String.logintitle} </h3> </Col>
                            </Row>
                            <Row style={{ padding: '0 2%' }} className={this.props.loading && "login-loading"}>
                                <Col md="12" lg="12" style={{}}>
                                    <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        {
                                            Inputs.map((row, ind) => {

                                                return (
                                                    <Row className="d-flex flex-row-reverse">
                                                        {
                                                            row.map((element, index) => {
                                                                return (
                                                                    <Field key={index}
                                                                        classfield={element.class ? element.class : ""}
                                                                        lang={lang}
                                                                        type={element.type}
                                                                        name={element.name}
                                                                        component={RenderField}
                                                                        label={lang === "ar" ? element.label.ar : element.label.en}
                                                                        placeholder={element.placeholder ? (lang === "ar" ? element.placeholder.ar : element.placeholder.en) : ""}
                                                                        options={element.options}
                                                                        optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                                        size={element.size}
                                                                    // title={lang === "ar" ? element.title.ar : element.title.en}
                                                                    />
                                                                )
                                                            })
                                                        }

                                                        <Col lg="6" md="6" c>
                                                            <div className="resend-code" onClick={() => this.GenerateCode()}
                                                                style={{ float: lang === "ar" ? 'right' : 'left' }}> <i className="fa fa-reply"></i> </div>
                                                            <Row className="code-login" style={{ float: lang === "ar" ? 'right' : 'left', direction: 'ltr' }}>
                                                                <span className={'litter' + 1}> {code[0]} </span>
                                                                <span className={'litter' + 2}> <div className="span2"> {code[1]} </div> </span>
                                                                <span className={'litter' + 3}> {code[2]} </span>
                                                                <span className={'litter' + 4}> <div className="span4"> {code[3]} </div> </span>
                                                                <span className={'litter' + 5}> {code[4]} </span>
                                                            </Row>
                                                            {this.state.codeErr &&
                                                                // <Col md>
                                                                <div className="RightAlign" style={{ marginTop: '10px', width: '44%' }}>
                                                                    <span className="mt-3" style={{ color: 'red', fontSize: '0.8rem' }}> {String.codeErr} </span> </div>
                                                                // </Col>
                                                            }
                                                        </Col>
                                                    </Row>
                                                )
                                            })
                                        }

                                        <Col md="12" style={{ textAlign: localStorage.getItem("Language") === "en" || localStorage.getItem("Language") === "" ? "right" : "" }}>
                                            <Link to='/forget-password'
                                                className={lang === "ar" ? " login-forget-ar login-click" : " login-forget-en login-click"} > <p className="forget-pass">  {String.forgetPass}  </p> </Link>
                                        </Col>

                                        <Col md="12" className="login-submit-Btn" style={{ marginTop: '2%', textAlign: lang === "ar" ? "right" : 'left' }} id="loginBtn">
                                            <Button type="submit" className="btn submitBtn" disabled={submitting} >
                                                {String.logintitle}
                                                {/* {String.loginBtn}  */}
                                            </Button>
                                        </Col>
                                    </Form>
                                    <Row className="login-ques mt-2 mb-2" >

                                        <Col lg="12" md="12" className="p-0 headingMobile" style={{ textAlign: localStorage.getItem("Language") === "ar" || localStorage.getItem("Language") === "" ? "right" : "" }}>
                                            <p style={{ float: lang === "ar" ? "right" : 'left', margin: "0px 3%", fontSize: "18px", color: "rgb(67, 67, 67)" }}> {String.noAccount}
                                                <Link to={{ pathname: '/registeration', state: { redirect: this.props.location.state ? this.props.location.state.redirect : null } }} className="login-click" style={{ fontSize: "18px" }} > {String.signup} </Link>
                                            </p>
                                        </Col>



                                    </Row>

                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        lang: state.login.language,
        token: state.login.token,
        loading: state.login.loading
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        LoginRequest,
        changeLang
        // visit
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(Login));
